import { AbTestConfig } from '@sprd/sprd-abtest-next/types';
import { atom, useAtomValue } from 'jotai';

export const abTestConfigAtom = atom<AbTestConfig | null>(null);

export const useAbTestConfig = (): AbTestConfig => {
  const config = useAtomValue(abTestConfigAtom);
  if (!config) {
    console.warn('abTestConfigAtom is not set');
    return { features: {}, tracking: {} };
  }
  return config;
};

export const useIsAbTestFeatureEnabled = (
  featureName: string,
  options?: { expectedState?: string; fallback?: boolean }
) => {
  const { expectedState = 'on', fallback = false } = options ?? {};
  const config = useAbTestConfig();
  const featureState = config.features[featureName];
  return featureState !== undefined ? featureState === expectedState : fallback;
};
